import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MeetingDoctorPageRoutingModule } from './meeting-doctor-routing.module';

import { MeetingDoctorPage } from './meeting-doctor.page';
import { SharedComponentsModule } from 'src/app/shared/modules/shared-components/shared-components.module';
import { SharedPipesModule } from 'src/app/shared/modules/shared-pipes/shared-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedPipesModule,
    MeetingDoctorPageRoutingModule,
    SharedComponentsModule
  ],
  declarations: [MeetingDoctorPage]
})
export class MeetingDoctorPageModule {}
